import Vue from 'vue'
import eventBus from '@/libs/event-bus'


/**
 * Fetch Wrapper
 * @param method {string} - http method
 * @param URL {string} - either a complete link or the resource point
 * @param metaOnly {boolean} - tell the api to only return the meta data
 * @param onError {function} - callback on error, optional
 * @returns JSON or error
 */
const http = async (method, URL, metaOnly, onError) => {
	if (method !== 'GET') return console.warn('unsupported http method', method)
	let url = URL
	
	try {
		let result = null
		const options = {
			method: method,
			headers: new Headers({
				'Accept': 'application/json',
				'Access-Control-Allow-Credentials': true
			})
		}
		if (metaOnly) options.headers.append('Meta-Only', 'true')
		
		if (!url.startsWith('http')) {
			let apiEndpoint = process.env.VUE_APP_API_ENDPOINT

			if (!apiEndpoint.startsWith('/')) {
				apiEndpoint = '/' + apiEndpoint
			}

			if (!apiEndpoint.endsWith('/')) {
				apiEndpoint += '/'
			}
			
			if (url.startsWith('/')) {
				url = url.slice(1)
			}
			
			url = apiEndpoint + url
			
			// append base url if the app is built for preview server, so it always uses the live api
			url = process.env.VUE_APP_BASE_URL + url
		}
		
		const response = await fetch(url, options)
		
		if (response.ok) {
			result = await response.json()
		} else { // response status code is >= 400
			if (onError) onError(url)
			else throw Error(response.statusText)
		}
		return result
	} catch (response) {
		eventBus.$emit('network-error', {url: url, response: response}) // App.vue will handle the error
		throw Error(`HTTP-error: ${response.statusText} on ${url}`)
	}
}


/**
 * Convert an Object into an URL-encoded query String
 * @param params {Object} - Object with {param-name: value}
 * @returns string
 */
http.convertParamsToUrlQuery = function (params) {
	let params_str = '?'
	
	for (let [key, value] of Object.entries(params)) {
		let test_str = JSON.stringify(value)
		
		if (!test_str || test_str === 'null' || String(value).trim() === '') continue
		
		if (Array.isArray(value) && value.length === 1) value = value[0]
		
		if (Array.isArray(value)) {
			let arr = []
			
			for (let i of value) {
				arr.push(encodeURIComponent(i))
			}
			
			let array_string = `[${arr.toString()}]` // dont encode [] and ,
			
			params_str += encodeURIComponent(key) + '=' + array_string + '&'
		} else if (value instanceof Object) {
			if (!Object.keys(value).length) continue
			
			let obj = {}
			
			for (let objKey of Object.keys(value)) {
				obj[objKey] = encodeURIComponent(value[objKey])
			}
			
			params_str += encodeURIComponent(key) + '=' + JSON.stringify(obj) + '&'
			
		} else params_str += encodeURIComponent(key) + '=' + encodeURIComponent(value) + '&'
	}
	
	params_str = params_str.slice(0, -1)// remove last '&'
	
	// console.log('params string:', params_str)
	
	return params_str
}


/**
 * converts a string to its native type
 * @param param {string}
 * @returns converted String
 */
http.parseQueryParam = function (param) {
	try {
		// parse number, arrays and objects
		param = JSON.parse(param)
	} catch {/* value is a string */
	}
	return param
}

/**
 * @param url
 * @param params
 * @param metaOnly
 * @returns {Promise<null|{headers: Headers, data: null}>}
 */
http.get = (url, metaOnly) => {
	return http('GET', url, metaOnly)
}

Vue.prototype.$http = http

export default http